import _ from "lodash";

/**
 * Similar to lodash's _.clamp, but returns the value if it is within the range, or capped to the specified min/max.
 * @param {*} props
 * @param {*} props.value
 * @param {*} props.min
 * @param {*} props.max
 * @returns value if within range of min or max,
 * otherwise returns value of min or max if value is outside of that range
 */
export default function bracket({ value, min, max }) {
  return _.min([_.max([value, min]), max]);
}
